import { authFetch } from "@/lib/api-client";
import type { MarketplaceNotificationSettingsRow } from "@/features/admin/marketplace/types/admin-marketplace.types";

const BASE_PATH = "/marketplace/admin/notification-settings";

export async function fetchMarketplaceNotificationSettings(): Promise<MarketplaceNotificationSettingsRow> {
  const { data } = await authFetch<MarketplaceNotificationSettingsRow>(BASE_PATH);
  return data;
}

export async function updateMarketplaceNotificationSettings(
  input: Partial<Omit<MarketplaceNotificationSettingsRow, "updatedByName" | "updatedAt" | "slackConfigured">>,
): Promise<MarketplaceNotificationSettingsRow> {
  const { data } = await authFetch<MarketplaceNotificationSettingsRow>(BASE_PATH, {
    method: "PUT",
    body: JSON.stringify(input),
  });
  return data;
}
